import api from '../../services/api';

// Action Types
export const COMMUNICATION_LOADING = 'COMMUNICATION_LOADING';
export const COMMUNICATION_ERROR = 'COMMUNICATION_ERROR';

// Email Templates
export const GET_EMAIL_TEMPLATES_SUCCESS = 'GET_EMAIL_TEMPLATES_SUCCESS';
export const CREATE_EMAIL_TEMPLATE_SUCCESS = 'CREATE_EMAIL_TEMPLATE_SUCCESS';
export const UPDATE_EMAIL_TEMPLATE_SUCCESS = 'UPDATE_EMAIL_TEMPLATE_SUCCESS';
export const DELETE_EMAIL_TEMPLATE_SUCCESS = 'DELETE_EMAIL_TEMPLATE_SUCCESS';

// WhatsApp Templates
export const GET_WHATSAPP_TEMPLATES_SUCCESS = 'GET_WHATSAPP_TEMPLATES_SUCCESS';
export const CREATE_WHATSAPP_TEMPLATE_SUCCESS = 'CREATE_WHATSAPP_TEMPLATE_SUCCESS';

// Campaigns
export const GET_CAMPAIGNS_SUCCESS = 'GET_CAMPAIGNS_SUCCESS';
export const CREATE_CAMPAIGN_SUCCESS = 'CREATE_CAMPAIGN_SUCCESS';
export const EXECUTE_CAMPAIGN_SUCCESS = 'EXECUTE_CAMPAIGN_SUCCESS';

// Communication
export const SEND_INVOICE_SUCCESS = 'SEND_INVOICE_SUCCESS';
export const SEND_BIRTHDAY_WISHES_SUCCESS = 'SEND_BIRTHDAY_WISHES_SUCCESS';
export const SEND_OFFER_NOTIFICATION_SUCCESS = 'SEND_OFFER_NOTIFICATION_SUCCESS';

// Configuration
export const UPDATE_EMAIL_CONFIG_SUCCESS = 'UPDATE_EMAIL_CONFIG_SUCCESS';
export const UPDATE_WHATSAPP_CONFIG_SUCCESS = 'UPDATE_WHATSAPP_CONFIG_SUCCESS';

// Analytics
export const GET_COMMUNICATION_STATS_SUCCESS = 'GET_COMMUNICATION_STATS_SUCCESS';

// WhatsApp Status
export const GET_WHATSAPP_STATUS_REQUEST = 'GET_WHATSAPP_STATUS_REQUEST';
export const GET_WHATSAPP_STATUS_SUCCESS = 'GET_WHATSAPP_STATUS_SUCCESS';
export const GET_WHATSAPP_STATUS_FAILURE = 'GET_WHATSAPP_STATUS_FAILURE';

// Email Template Actions
export const getEmailTemplates = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const params = new URLSearchParams();
    if (filters.type) params.append('type', filters.type);
    if (filters.is_active !== undefined) params.append('is_active', filters.is_active);
    
    const response = await api.get(`/communication/email-templates?${params.toString()}`);
    
    dispatch({
      type: GET_EMAIL_TEMPLATES_SUCCESS,
      payload: response.data.data || []
    });
    
    return { success: true, data: response.data.data || [] };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch email templates';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

export const createEmailTemplate = (templateData) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const response = await api.post('/communication/email-templates', templateData);
    
    dispatch({
      type: CREATE_EMAIL_TEMPLATE_SUCCESS,
      payload: response.data.data
    });
    
    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to create email template';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

export const updateEmailTemplate = (id, templateData) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const response = await api.put(`/communication/email-templates/${id}`, templateData);
    
    dispatch({
      type: UPDATE_EMAIL_TEMPLATE_SUCCESS,
      payload: response.data.data
    });
    
    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update email template';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

export const deleteEmailTemplate = (id) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    await api.delete(`/communication/email-templates/${id}`);
    
    dispatch({
      type: DELETE_EMAIL_TEMPLATE_SUCCESS,
      payload: id
    });
    
    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to delete email template';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

// WhatsApp Template Actions
export const getWhatsAppTemplates = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const params = new URLSearchParams();
    if (filters.type) params.append('type', filters.type);
    if (filters.is_active !== undefined) params.append('is_active', filters.is_active);
    
    const response = await api.get(`/communication/whatsapp-templates?${params.toString()}`);
    
    dispatch({
      type: GET_WHATSAPP_TEMPLATES_SUCCESS,
      payload: response.data.data || []
    });
    
    return { success: true, data: response.data.data || [] };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch WhatsApp templates';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

export const createWhatsAppTemplate = (templateData) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const response = await api.post('/communication/whatsapp-templates', templateData);
    
    dispatch({
      type: CREATE_WHATSAPP_TEMPLATE_SUCCESS,
      payload: response.data.data
    });
    
    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to create WhatsApp template';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

export const updateWhatsAppTemplate = (id, templateData) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const response = await api.put(`/communication/whatsapp-templates/${id}`, templateData);
    
    dispatch({
      type: CREATE_WHATSAPP_TEMPLATE_SUCCESS,
      payload: response.data.data
    });
    
    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update WhatsApp template';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

export const deleteWhatsAppTemplate = (id) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    await api.delete(`/communication/whatsapp-templates/${id}`);
    
    dispatch({
      type: CREATE_WHATSAPP_TEMPLATE_SUCCESS,
      payload: id
    });
    
    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to delete WhatsApp template';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

// Campaign Actions
export const getCampaigns = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.type) params.append('type', filters.type);
    
    const response = await api.get(`/communication/campaigns?${params.toString()}`);
    
    dispatch({
      type: GET_CAMPAIGNS_SUCCESS,
      payload: response.data.data || []
    });
    
    return { success: true, data: response.data.data || [] };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch campaigns';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

export const createCampaign = (campaignData) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const response = await api.post('/communication/campaigns', campaignData);
    
    dispatch({
      type: CREATE_CAMPAIGN_SUCCESS,
      payload: response.data.data
    });
    
    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to create campaign';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

export const executeCampaign = (campaignId) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const response = await api.post(`/communication/campaigns/${campaignId}/execute`);
    
    dispatch({
      type: EXECUTE_CAMPAIGN_SUCCESS,
      payload: response.data.data
    });
    
    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to execute campaign';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

// Communication Actions
export const sendInvoiceToCustomer = (invoiceId, customerId, methods, whatsappNumber = null) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const response = await api.post('/communication/send-invoice', {
      invoiceId,
      customerId,
      methods,
      whatsappNumber
    });
    
    dispatch({
      type: SEND_INVOICE_SUCCESS,
      payload: response.data.data
    });
    
    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to send invoice';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

export const sendBirthdayWishes = (discountPercentage = 10, methods = ['email', 'whatsapp'], imageData = null) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const response = await api.post('/communication/send-birthday-wishes', {
      discountPercentage,
      methods,
      imageData
    });
    
    dispatch({
      type: SEND_BIRTHDAY_WISHES_SUCCESS,
      payload: response.data.data
    });
    
    return { success: true, data: response.data.data || response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to send birthday wishes';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

export const sendOfferNotification = (offerDetails, targetCriteria = {}, methods = ['email', 'whatsapp'], imageData = null) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const response = await api.post('/communication/send-offer-notification', {
      offerDetails,
      targetCriteria,
      methods,
      imageData
    });
    
    dispatch({
      type: SEND_OFFER_NOTIFICATION_SUCCESS,
      payload: response.data.data
    });
    
    return { success: true, data: response.data.data || response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to send offer notification';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

// Configuration Actions
export const getEmailConfiguration = () => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const response = await api.get('/communication/email-configuration');
    
    dispatch({
      type: UPDATE_EMAIL_CONFIG_SUCCESS,
      payload: response.data.data
    });
    
    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch email configuration';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

export const getWhatsAppConfiguration = () => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const response = await api.get('/communication/whatsapp-configuration');
    
    dispatch({
      type: UPDATE_WHATSAPP_CONFIG_SUCCESS,
      payload: response.data.data
    });
    
    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch WhatsApp configuration';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

export const updateEmailConfiguration = (configData) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const response = await api.put('/communication/email-configuration', configData);
    
    dispatch({
      type: UPDATE_EMAIL_CONFIG_SUCCESS,
      payload: response.data.data
    });
    
    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update email configuration';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

export const updateWhatsAppConfiguration = (configData) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const response = await api.put('/communication/whatsapp-configuration', configData);
    
    dispatch({
      type: UPDATE_WHATSAPP_CONFIG_SUCCESS,
      payload: response.data.data
    });
    
    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update WhatsApp configuration';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

export const testEmailConfiguration = (configData) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const response = await api.post('/communication/test-email-configuration', configData);
    
    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to test email configuration';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

export const testWhatsAppConfiguration = (configData) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const response = await api.post('/communication/test-whatsapp-configuration', configData);
    
    return { success: true, data: response.data.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to test WhatsApp configuration';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

// Analytics Actions
export const getCommunicationStats = (startDate, endDate) => async (dispatch) => {
  try {
    dispatch({ type: COMMUNICATION_LOADING });
    
    const response = await api.get(`/communication/stats?startDate=${startDate}&endDate=${endDate}`);
    
    dispatch({
      type: GET_COMMUNICATION_STATS_SUCCESS,
      payload: response.data.data || []
    });
    
    return { success: true, data: response.data.data || [] };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch communication stats';
    dispatch({
      type: COMMUNICATION_ERROR,
      payload: message
    });
    return { success: false, message };
  }
};

// WhatsApp Status Action
export const getWhatsAppStatus = () => async (dispatch) => {
  try {
    dispatch({ type: GET_WHATSAPP_STATUS_REQUEST });
    
    const response = await api.get('/communication/whatsapp-status');
    
    dispatch({
      type: GET_WHATSAPP_STATUS_SUCCESS,
      payload: response.data.data || {}
    });
    
    return { success: true, data: response.data.data || {} };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch WhatsApp status';
    dispatch({
      type: GET_WHATSAPP_STATUS_FAILURE,
      payload: message
    });
    return { success: false, message };
  }
};